// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__GlUQF","image":"search_image__AvzM8"};